import { v4 as uuidv4 } from 'uuid';

const EXTENSION_SDK_RANDOM_USER_ID_NAME = 'KK_EXTENSION_SDK_USER';
export const KK_UTM_SOURCE = 'KKUtmSource';
export const KK_UTM_COMPAIGN = 'KKUtmCampaign';
export const KK_UTM_MEDIUM = 'KKUtmMedium';

export const getRandomUserId = () => {
  const userId = localStorage.getItem(EXTENSION_SDK_RANDOM_USER_ID_NAME);
  if (userId) {
    return userId;
  } else {
    const userId = uuidv4();
    localStorage.setItem(EXTENSION_SDK_RANDOM_USER_ID_NAME, userId);
    return userId;
  }
};

export const getUtmParamsForChromeExtension = () => {
  return {
    utmSource: localStorage.getItem(KK_UTM_SOURCE),
    utmCampaign: localStorage.getItem(KK_UTM_COMPAIGN),
    utmMedium: localStorage.getItem(KK_UTM_MEDIUM),
  };
};
